//this block of code is webpack specific for dynamically loading all files from the img folder
const images = {};
function importAll(r) {
  return r.keys().forEach((key) => {
    //match on RUM code and optional direction
    let item = key.match(/(\d+[N|S|E|W]?[N|S|E|W]?)/)[0];
    images[item] = r(key).default;
  });
}
importAll(
  require.context(
    "@mrwa/crashmap/esriControls/crashmapTools/collisionDiagrams/img",
    false,
    /\.(jpg)$/
  )
);

export default images;
